/** Home page Header */

export default {
    init() {
        const isMobile = window.innerWidth < 768;
        const video = document.getElementById('main-video');
        const homeVideo = document.querySelector('.header--home .header__media');

        if (video) {
            let desktopSrc = video.dataset.src;
            let mobileSrc = video.dataset.srcMobile;

            if (isMobile && mobileSrc) {
                // video.insertAdjacentHTML('beforeend', "<source type='video/mp4' src='" + mobileSrc + "'>");
                video.innerHTML = "<source type='video/mp4' src='" + mobileSrc + "'>";
            } else {
                // video.insertAdjacentHTML('beforeend', "<source type='video/mp4' src='" + desktopSrc + "'>");
                video.innerHTML = "<source type='video/mp4' src='" + desktopSrc + "'>";
            }

            video.load();
            video.play();

            let wasPaused = false;
            let pauseAt = isMobile ? 10.6 : 11;
            let pauseDuration = 1000 * 20;

            homeVideo.addEventListener('timeupdate', function() {
                let currentTime = this.currentTime;

                const handleTimeout = () => this.play();

                if (currentTime < pauseAt) {
                    wasPaused = false;
                } else if (currentTime >= pauseAt && !wasPaused) {
                    wasPaused = true;
                    this.pause();
                    setTimeout(handleTimeout.bind(this), pauseDuration);
                }
            });
        }
    },
    lazyloadVideoSource(video) {
        if (video && video.dataset.loading === 'lazy') {
            for (let source in video.children) {
                let videoSource = video.children[source];
                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                }
            }
            video.dataset.loading = 'loaded';
            video.load();
            video.play();
        }
    }
}
